import * as d3 from "d3";
import {xScale} from "../../mocks/projectsMock";
import {ITypeRadar} from "../../types";
interface StopData {
  offset: string;
  color: string;
}
export const wrapText = (
  text: string,
  maxWidth: number,
  x: number,
  y: number,
  mainGroup: any,
  isActive?: boolean
): string[] => {
  const words: string[] = text.split(" ");
  let line: string = "";
  const lines: string[] = [];
  let wasTruncated = false;

  words.forEach((word: string, index: number) => {
    const testLine: string = line + word + " ";
    const testText = mainGroup
      .append("text")
      .attr("x", x)
      .attr("y", y)
      .text(testLine)
      .style("visibility", "hidden")
      .style("font-size", `13px`)
      .style("font-weight", "400")
      .style("pointer-events", "none")
      .style("text-anchor", "start");

    const node = testText.node();
    const testWidth: number = node ? node.getBBox().width : 0;
    testText.remove();

    if (testWidth > maxWidth && line) {
      if (line.trim().endsWith(" и")) {
        lines.push(line.trim().slice(0, -2));
        line = "и " + word + " ";
      } else {
        lines.push(line.trim());
        line = word + " ";
      }
    } else {
      line = testLine;
    }
    if (word === "и" && index < words.length - 1) {
      const nextWord = words[index + 1];
      const testLineWithNextWord = line + nextWord + " ";
      const testTextWithNextWord = mainGroup
        .append("text")
        .attr("x", x)
        .attr("y", y)
        .text(testLineWithNextWord)
        .style("visibility", "hidden")
        .style("font-size", `13px`)
        .style("font-weight", "400")
        .style("pointer-events", "none")
        .style("text-anchor", "start");

      const testWidthWithNextWord: number = testTextWithNextWord.node()
        ? testTextWithNextWord.node().getBBox().width
        : 0;
      testTextWithNextWord.remove();

      if (testWidthWithNextWord <= maxWidth) {
        line = testLineWithNextWord;
        words[index + 1] = "";
      }
    }

    if (!isActive && lines.length === 1) {
      if (testWidth > maxWidth && line) {
        wasTruncated = true;
        return;
      }
    }
  });

  if (line.trim()) {
    lines.push(line.trim());
  }

  if (!isActive && lines.length > 2) {
    lines.length = 2;
    lines[1] = lines[1].replace(/\s+$/, "") + " ...";
  }
  return lines;
};

export const showLabel = (
  title: string,
  x: number,
  y: number,
  mainGroup: any,
  id: number | string,
  idName: string,
  innerColor: {back: string; color: string},
  showAllLabels: boolean,
  typeRadar?: ITypeRadar,
  scale?: number,
  fontSizeGet?: number,
  isActive?: boolean,
  isMolecule?: boolean,
  isBigLabel?: boolean,
  xStartLabel?: number,
  yStartLabel?: number,
  rayAngleLabel?: number,
  isNationalProjects?: boolean,
  backColor?: string
) => {
  const isBigLabelMoleculeTwo =
    isBigLabel && typeRadar === "moleculeTwo"
      ? // (isBigLabel && typeRadar === "molecula")
        true
      : false;

  const isBigLabelMolecule =
    isBigLabel && typeRadar === "molecula"
      ? // (isBigLabel && typeRadar === "molecula")
        true
      : false;

  const offset = 1 * xScale;
  const fontSize =
    (scale && scale <= 1.6 && typeRadar === "map"
      ? (fontSizeGet || 3) * 2
      : fontSizeGet || 7) * xScale;
  const paddingX = 3 * xScale;
  const paddingY = 1 * xScale;
  const extraOffset = 1 * xScale;

  const maxTextWidth = 120 * xScale;

  const lines: string[] = wrapText(
    title,
    maxTextWidth,
    x,
    y,
    mainGroup,
    isActive
  );

  let maxLineWidth: number = 0;
  lines.forEach((line: string) => {
    const testText = mainGroup
      .append("text")
      .attr("x", x)
      .attr("y", y)
      .text(line)
      .style("visibility", "hidden")
      .style("font-size", `${fontSize}px`)
      .style("font-weight", "400")
      .style("text-anchor", "start");

    const node = testText.node();
    const testWidth: number = node ? node.getBBox().width : 0;
    testText.remove();

    if (testWidth > maxLineWidth) {
      maxLineWidth = testWidth;
    }
  });

  const lineHeight = fontSize + 1;
  const textHeight = lines.length * lineHeight;
  const backgroundWidth = maxLineWidth + paddingX * 2;
  const backgroundHeight = textHeight + paddingY * 2;

  const angleDeg = rayAngleLabel ?? 0;
  const angleRad = (angleDeg * Math.PI) / 180;

  const isNear = (target: number, angle: number, delta = 15) =>
    Math.abs(((angle - target + 360) % 360) - 0) < delta ||
    Math.abs(((angle - target - 360) % 360) - 0) < delta;

  const maxOffset = 80;

  let backgroundRectX: number;

  // const backgroundRectX = !isBigLabelMoleculeTwo
  //   ? isBigLabelMolecule
  //     ? x > 0
  //       ? x - backgroundWidth - 5
  //       : x + offset + 4
  //     : x > 0
  //     ? x + offset + 4
  //     : x - backgroundWidth - 5
  //   : x > 0
  //   ? y > 0
  //     ? xStartLabel! - backgroundWidth - ySin! / 10 + xCos! / 3
  //     : xStartLabel! - backgroundWidth - ySin! / 10
  //   : y > 0
  //   ? xStartLabel! - ySin! / 10
  //   : xStartLabel! - backgroundWidth / 2 - (ySin || 0) / 1.3;
  if (isBigLabelMoleculeTwo) {
    if (isNear(90, angleDeg) || isNear(270, angleDeg)) {
      backgroundRectX = (xStartLabel ?? 0) - backgroundWidth / 2;
    } else if (isNear(0, angleDeg) || isNear(180, angleDeg)) {
      const extraDistance = 7;
      if ((xStartLabel ?? 0) > 0) {
        backgroundRectX =
          (xStartLabel ?? 0) -
          Math.min(maxOffset, backgroundWidth / 2) -
          backgroundWidth / 2 -
          extraDistance;
      } else {
        backgroundRectX =
          (xStartLabel ?? 0) +
          Math.min(maxOffset, backgroundWidth / 2) -
          backgroundWidth / 2 +
          extraDistance;
      }
    } else {
      if ((xStartLabel ?? 0) > 0) {
        backgroundRectX =
          (xStartLabel ?? 0) -
          Math.min(maxOffset, backgroundWidth / 2) -
          backgroundWidth / 2;
      } else {
        backgroundRectX =
          (xStartLabel ?? 0) +
          Math.min(maxOffset, backgroundWidth / 2) -
          backgroundWidth / 2;
      }
    }
  } else {
    backgroundRectX = isBigLabelMolecule
      ? x > 0
        ? x - backgroundWidth - 5
        : x + offset + 4
      : x > 0
      ? x + offset + 4
      : x - backgroundWidth - 5;
  }

  const backgroundRectY = !isBigLabelMoleculeTwo
    ? y - offset - backgroundHeight - extraOffset + 6
    : isNear(0, angleDeg) || isNear(180, angleDeg)
    ? (yStartLabel ?? 0) - 5
    : (yStartLabel ?? 0) > 0
    ? (yStartLabel ?? 0) - backgroundHeight - 5
    : (yStartLabel ?? 0) + 5;

  const darkerInnerColor = d3.color(innerColor.back)?.darker(3).toString();

  const labelGroup = mainGroup
    .append("g")
    .attr("class", `tooltip-group-${idName}${id}`)
    .style("pointer-events", "none");

  labelGroup
    .append("rect")
    .attr("class", `tooltip-background-${idName + id}`)
    .attr("x", backgroundRectX)
    .attr("y", backgroundRectY)
    .attr("width", backgroundWidth)
    .attr("height", backgroundHeight)
    .attr(
      "fill",
      isActive
        ? typeRadar !== "moleculeTwo"
          ? isNationalProjects
            ? backColor
            : innerColor.back
          : "rgba(14, 101, 107, 0.9)"
        : isNationalProjects
        ? backColor
        : `url(#${idName + id}-gradient)`
    )
    .attr("rx", 6)
    .attr("ry", 6)
    .attr("opacity", showAllLabels ? (isActive ? 1 : isMolecule ? 0 : 0.4) : 1)
    .style("pointer-events", "none");

  labelGroup
    .append("defs")
    .append("linearGradient")
    .attr("id", `${idName + id}-gradient`)
    .attr("x1", "0%")
    .attr("y1", "0%")
    .attr("x2", "0%")
    .attr("y2", "100%")
    .selectAll("stop")
    .data([
      {
        offset: "0%",
        color: typeRadar !== "moleculeTwo" ? innerColor.back : "#00F0FF",
      },
      {offset: "100%", color: "rgba(0, 0, 0, 0)"},
    ])
    .enter()
    .append("stop")
    .attr("offset", (d: StopData) => d.offset)
    .attr("stop-color", (d: StopData) => d.color);
  // .attr("stroke", isActive ? "white" : "none");
  // .attr("stroke-width", isActive ? 0.6 : 0);

  // .on("mouseover", function (this: SVGRectElement) {
  //   d3.select(this).attr("opacity", 1);
  //   d3.select(this)
  //     .attr("stroke", "#fff")
  //     .attr("stroke-width", 0.4)
  //     .attr("stroke-opacity", 0.8);
  //   if (showAllLabels) {
  //     d3.select(this).raise();
  //     mainGroup.selectAll(`.tooltip-text-${idName + id}`).raise();
  //     mainGroup.selectAll(`.tooltip-text-${idName + id}`).attr("opacity", 1);
  //   }
  // })
  // .on("mouseout", function (this: SVGRectElement) {
  //   d3.select(this).attr("opacity", 0.8);
  //   d3.select(this)
  //     .attr("stroke", "#fff")
  //     .attr("stroke-width", 0.4)
  //     .attr("stroke-opacity", 0);
  //   mainGroup.selectAll(`.tooltip-text-${idName + id}`).attr("opacity", 0.6);
  // });

  const xText = !isBigLabelMoleculeTwo
    ? isBigLabelMolecule
      ? x > 0
        ? x - backgroundWidth / 2 - 6
        : x + backgroundWidth / 2 + 6
      : x > 0
      ? x + backgroundWidth / 2 + 6
      : x - backgroundWidth / 2 - 6
    : isNear(90, angleDeg) || isNear(270, angleDeg)
    ? xStartLabel!
    : isNear(90, angleDeg) || isNear(270, angleDeg)
    ? xStartLabel!
    : isNear(0, angleDeg)
    ? backgroundRectX + backgroundWidth / 2
    : isNear(180, angleDeg)
    ? backgroundRectX + backgroundWidth / 2
    : x > 0
    ? backgroundRectX + backgroundWidth / 2
    : backgroundRectX + backgroundWidth / 2;

  lines.forEach((line: string, index: number) => {
    labelGroup
      .append("text")
      .attr("id", `tooltip-${idName + id}`)
      .attr("class", `tooltip-text-${idName + id}`)
      .attr("x", xText)
      .attr("y", backgroundRectY! + paddingY + (index + 0.5) * lineHeight)
      .text(line)
      .style(
        "fill",
        isActive
          ? isNationalProjects
            ? backColor === "#59FFAC" || backColor === "#00F0FF"
              ? "#000000"
              : "#ffffff"
            : innerColor.color
          : isNationalProjects
          ? backColor === "#59FFAC" || backColor === "#00F0FF"
            ? "#000000"
            : "#ffffff"
          : "#ffffff"
      )
      .style("font-size", `${fontSize}px`)
      .style("font-weight", "400")
      .style("text-anchor", "middle")
      .style("pointer-events", "none")
      .attr("opacity", showAllLabels ? (isActive ? 1 : 0.6) : 1)
      .attr("dy", "0.35em");
  });

  raisePointLabel(mainGroup, id, idName);
};

export const toogleDotsCoordinatesFintech = (
  x: number,
  y: number,
  clusterId: number | string,
  svgRef: React.RefObject<SVGSVGElement>,
  showAllLabels: boolean,
  showLabel: (
    name: string,
    x: number,
    y: number,
    mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
    id: number | string,
    type: string,
    color: {back: string; color: string},
    showAllLabels: boolean
  ) => void,
  hideLabel: () => void,
  clusterName: string,
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
  innerColor: {back: string; color: string}
) => {
  hideLabel();
  if (svgRef.current) {
    mainGroup
      .select(`#outline-circle-${clusterId}`)
      .transition()
      .duration(1000)
      .attr("cx", x)
      .attr("cy", y);
    mainGroup
      .select(`#outline-inner-circle-${clusterId}`)
      .transition()
      .duration(1000)
      .attr("cx", x)
      .attr("cy", y);
    mainGroup
      .select(`#inline-circle-${clusterId}`)
      .transition()
      .duration(1000)
      .attr("cx", x)
      .attr("cy", y);
  }

  if (showAllLabels) {
    setTimeout(
      () =>
        showLabel(
          clusterName,
          x,
          y,
          mainGroup,
          clusterId,
          "cluster",
          innerColor,

          showAllLabels
        ),
      1000
    );
  }
};

export const hideLabel = (
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
  clusterId: number | string,
  id?: number,
  idName?: string
) => {
  mainGroup.selectAll(`.tooltip-background-cluster${clusterId}`).remove();
  mainGroup.selectAll(`.tooltip-text-cluster${clusterId}`).remove();
  if (idName && id) {
    mainGroup.selectAll(`.tooltip-group-${idName}${id}`).remove();
    mainGroup.selectAll(`.tooltip-background-${idName + id}`).remove();
    mainGroup.selectAll(`.tooltip-text-${idName + id}`).remove();
  }
};

export const removePointLabel = (
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
  id: number | string,
  idName: string
) => {
  mainGroup.selectAll(`.tooltip-group-${idName}${id}`).remove();
  mainGroup.selectAll(`.tooltip-background-${idName}${id}`).remove();
  mainGroup.selectAll(`.tooltip-text-${idName}${id}`).remove();
};

export const raisePointLabel = (
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>,
  id: number | string,
  idName: string
) => {
  const labelGroup = mainGroup.select(`g.tooltip-group-${idName}${id}`);
  if (!labelGroup.empty()) {
    labelGroup.raise();
    return;
  }

  mainGroup.selectAll(`.tooltip-background-${idName}${id}`).raise();
  mainGroup.selectAll(`.tooltip-text-${idName}${id}`).raise();
};

export const raiseAllTechnologyLabels = (
  mainGroup: d3.Selection<SVGGElement, unknown, null, undefined>
) => {
  mainGroup.selectAll("g[class*='tooltip-group-technology']").each(function () {
    d3.select(this).raise();
  });
};

export const showLabelMolecule = (
  title: string,
  x: number,
  y: number,
  mainGroup: any,
  id: number | string,
  idName: string,
  innerColor: {back: string; color: string},
  showAllLabels: boolean,
  typeRadar?: ITypeRadar,
  scale?: number,
  fontSizeGet?: number,
  isActive?: boolean,
  isMolecule?: boolean,
  isBigLabel?: boolean,
  xStartLabel?: number,
  yStartLabel?: number
) => {
  const offset = 1 * xScale;
  const fontSize =
    (scale && scale <= 1.6 && typeRadar === "map"
      ? (fontSizeGet || 5) * 2
      : fontSizeGet || 5) * xScale;
  const paddingX = 3 * xScale;
  const paddingY = 1 * xScale;
  const extraOffset = 1 * xScale;

  const maxTextWidth = 150 * xScale;

  const lines: string[] = wrapText(
    title,
    maxTextWidth,
    x,
    y,
    mainGroup,
    isActive
  );

  let maxLineWidth: number = 0;
  lines.forEach((line: string) => {
    const testText = mainGroup
      .append("text")
      .attr("x", x)
      .attr("y", y)
      .text(line)
      .style("visibility", "hidden")
      .style("font-size", `${fontSize}px`)
      .style("font-weight", "400")
      .style("text-anchor", "start");

    const node = testText.node();
    const testWidth: number = node ? node.getBBox().width : 0;
    testText.remove();

    if (testWidth > maxLineWidth) {
      maxLineWidth = testWidth;
    }
  });

  const lineHeight = fontSize + 1;
  const textHeight = lines.length * lineHeight;
  const backgroundWidth = maxLineWidth + paddingX * 2;
  const backgroundHeight = textHeight + paddingY * 2;

  const backgroundRectX =
    xStartLabel! > x ? xStartLabel! : xStartLabel! - backgroundWidth;
  const backgroundRectY =
    yStartLabel! > y ? yStartLabel! : yStartLabel! - backgroundHeight;

  const labelGroup = mainGroup
    .append("g")
    .attr("class", `tooltip-group-${idName}${id}`)
    .style("pointer-events", "none");

  labelGroup
    .append("rect")
    .attr("class", `tooltip-background-${idName + id}`)
    .attr("x", backgroundRectX)
    .attr("y", backgroundRectY)
    .attr("width", backgroundWidth)
    .attr("height", backgroundHeight)
    .attr("fill", isActive ? innerColor.back : `url(#${idName + id}-gradient)`)
    .attr("rx", 6)
    .attr("ry", 6)
    .attr("opacity", showAllLabels ? (isActive ? 1 : isMolecule ? 0 : 0.4) : 1)
    .style("pointer-events", "none");

  labelGroup
    .append("defs")
    .append("linearGradient")
    .attr("id", `${idName + id}-gradient`)
    .attr("x1", "0%")
    .attr("y1", "0%")
    .attr("x2", "0%")
    .attr("y2", "100%")
    .selectAll("stop")
    .data([
      {offset: "0%", color: innerColor.back},
      {offset: "100%", color: "rgba(0, 0, 0, 0)"},
    ])
    .enter()
    .append("stop")
    .attr("offset", (d: StopData) => d.offset)
    .attr("stop-color", (d: StopData) => d.color);

  const xText =
    xStartLabel! > x
      ? xStartLabel! + backgroundWidth / 2
      : xStartLabel! - backgroundWidth / 2;

  lines.forEach((line: string, index: number) => {
    labelGroup
      .append("text")
      .attr("id", `tooltip-${idName + id}`)
      .attr("class", `tooltip-text-${idName + id}`)
      .attr("x", xText)
      .attr("y", backgroundRectY! + paddingY + (index + 0.5) * lineHeight)
      .text(line)
      .style("fill", isActive ? "#000" : "#fff")
      .style("font-size", `${fontSize}px`)
      .style("font-weight", "400")
      .style("text-anchor", "middle")
      .style("pointer-events", "none")
      .attr("opacity", showAllLabels ? (isActive ? 1 : 0.6) : 1)
      .attr("dy", "0.35em");
  });

  raisePointLabel(mainGroup, id, idName);
};
